import React, { useRef } from "react";

import useContainerHeight from "../../../../common/useContainerHeight";
import { getTranslation } from "../../../../helpers/getLanguage";
import CustomScrollbar from "../../../common/CustomScrollbar";
import RowComponent from "./RowComponent";

const RowsComponents = ({ rows, componentsPicked, handlePickedComponent }) => {
  const tableRef = useRef(null);
  const [containerHeight] = useContainerHeight(tableRef, 20);

  const reportsTableStyle = {};
  containerHeight && (reportsTableStyle.height = containerHeight);

  return (
    <div className="components-container" ref={tableRef} style={reportsTableStyle}>
      {rows?.length > 0 ? (
        <CustomScrollbar right={-15} dependencies={[rows]}>
          {rows.map((row) => (
            <RowComponent
              key={row.id}
              row={row}
              componentsPicked={componentsPicked}
              handlePickedComponent={handlePickedComponent}
            />
          ))}
        </CustomScrollbar>
      ) : (
        <div className="flex-column report-placeholder text-center">
          <span>{getTranslation("NO_COMPONENTS_FOUND")}</span>
          <span>{getTranslation("NO_COMPONENTS_MESSAGE")}</span>
        </div>
      )}
    </div>
  );
};

export default RowsComponents;
